import { Component } from 'react';

/** Keeps an error on the workshop pages inside them, so the rest of the app
 *  stays up. A new `resetKey` (another page or view) tries again. */
export default class WorkshopBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="ws-root">
        <div className="ws-error">
          This page stopped on an error: {this.state.error.message || String(this.state.error)}
        </div>
      </div>
    );
  }
}
